// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --ion-item-background: transparent;
  --ion-item-color: var(--ion-color-light, #fff);
}`, "",{"version":3,"sources":["webpack://./src/app/core/modules/shared/components/modal-search/modal-search.component.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,8CAAA;AACF","sourcesContent":["ion-content {\n  --ion-item-background: transparent;\n  --ion-item-color: var(--ion-color-light, #fff);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
